<app-page-header></app-page-header>

<div class="indexing-page">
  @if (showContactAdminEmpty) {
    <div class="capability-empty-state">
      <p>Client access denied</p>
    </div>
  } @else {
  <div class="ops-index-tabs" role="tablist" aria-label="Operational navigation tabs">
    <button type="button" class="ops-index-tab active" aria-current="page">
      <span>Indexing</span>
    </button>
    <button
      type="button"
      class="ops-index-tab"
      [class.is-disabled]="capabilities && !capabilities.extractionEnabled"
      [disabled]="capabilities ? !capabilities.extractionEnabled : false"
      [attr.title]="capabilities && !capabilities.extractionEnabled ? 'Extraction is not enabled for this client' : null"
      (click)="navigateToOperationsRequestAnalytics()"
      >
      <span>Extraction</span>
    </button>
  </div>

  <div class="content-section">
    <div class="section-header">
      <div class="section-title-wrap">
        <button class="section-back-btn" (click)="router.navigate(['/home'])" title="Back to Dashboard" aria-label="Back to Dashboard">
          <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
        <h2 class="section-title">Indexing</h2>

        <div class="section-search-box" [class.is-disabled]="allRows.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            [disabled]="allRows.length === 0"
            (input)="onSearchChange()"
            placeholder="Search File Name, CR, Request ID" />
        </div>
      </div>

      <div class="section-actions">
        <button type="button" class="loans-simple-btn" title="Add Package" (click)="onAddLoansClick()">+ Package</button>
        <div class="header-controls-context-slot" [class.has-custom-controls]="selectedTimeFilter === 'custom'">
          @if (selectedTimeFilter === 'custom') {
            <div class="custom-date-controls">
              <span class="date-prefix-label">From</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    type="text"
                    [value]="startDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('start', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('start')"
                    (click)="openDateTimePopup('start', $event)"
                    title="Start date and time" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('start', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('start')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [maxDate]="getPopupMaxDate('start')"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="Start time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="Start hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="Start minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="Start period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>

              <span class="date-prefix-label">To</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    [class.is-invalid]="endDateInvalid"
                    type="text"
                    [value]="endDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('end', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('end')"
                    (click)="openDateTimePopup('end', $event)"
                    [attr.title]="dateRangeValidationMessage || 'End date and time'" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('end', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('end')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [minDate]="getPopupMinDate('end')"
                        [maxDate]="getTodayDateForPopup()"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="End time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="End hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="End minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="End period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="filter-select-wrapper">
          <select
            class="filter-select"
            [(ngModel)]="selectedTimeFilter"
            (change)="onTimeFilterChange()"
            title="Date filter">
            <option value="today">Last 24 Hours</option>
            <option value="last7">Last 7 Days</option>
            <option value="last30">Last 30 Days</option>
            <option value="custom">Custom</option>
          </select>
          <span class="material-icons dropdown-indicator" aria-hidden="true">arrow_drop_down</span>
        </div>
      </div>
    </div>

    @if (isLoading) {
      <div class="indexing-loading-wrapper">
        <div class="page-loading-state">
          <div class="docsila-loader">
            <div class="beat-loader">
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
            </div>
            <p class="loader-text">Loading indexing records...</p>
          </div>
        </div>
      </div>
    } @else {
      <div class="indexing-table-wrapper" (scroll)="onIndexingTableScroll()">
        @if (displayedRows.length > 0) {
        <table class="indexing-table">
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('fileName')">
                <button type="button" class="sort-trigger">
                  <span>File Name</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('fileName')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('pageCount')">
                <button type="button" class="sort-trigger">
                  <span>Total Pages</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('pageCount')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('miscPages')">
                <button type="button" class="sort-trigger">
                  <span>Misc Pages</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('miscPages')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('docs')">
                <button type="button" class="sort-trigger">
                  <span>Docs</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('docs')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('lastModifiedOn')">
                <button type="button" class="sort-trigger">
                  <span>Started</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('lastModifiedOn')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('durationSeconds')">
                <button type="button" class="sort-trigger">
                  <span>Duration</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('durationSeconds')"></span>
                </button>
              </th>
              <th class="sortable center" (click)="sortBy('status')">
                <button type="button" class="sort-trigger">
                  <span>Status</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('status')"></span>
                </button>
              </th>
              <th class="center">
                <button type="button" class="sort-trigger" disabled>
                  <span>Actions</span>
                </button>
              </th>
            </tr>
          </thead>

          <tbody>
            @for (row of displayedRows; track row.requestId || row.fileName) {
              <tr>
                <td>
                  <div class="file-name-cell">
                    <button
                      type="button"
                      class="loan-number-link file-name-link"
                      [title]="row.status !== 'Completed' ? 'Indexing in progress — available once completed' : row.fileName"
                      [disabled]="row.status !== 'Completed'"
                      (click)="navigateToSource(row)">
                      <span class="file-name-text">{{ row.fileName }}</span>
                    </button>
                    <span class="file-client-id" [title]="'CR:' + (row.clientId || '-')">CR:{{ row.clientId || '-' }}</span>
                  </div>
                </td>
                <td class="center">{{ row.pageCount ?? '-' }}</td>
                <td class="center">{{ row.miscPages }}</td>
                <td class="center">{{ row.docs }}</td>
                <td class="center">{{ formatDate(row.lastModifiedOn) }}</td>
                <td class="center">{{ formatDurationInMinutes(row.durationSeconds) }}</td>
                <td class="center status-cell">
                  <div class="status-cell-content">
                    <span class="status-badge" [ngClass]="getHilStatusClass(row)">
                      <span class="status-label">{{ getHilStatusLabel(row) }}</span>
                      @if (authService.isAdmin) {
                        <button
                          type="button"
                          class="btn-action btn-icon-only btn-status-eye status-inline-eye status-inline-info"
                          [attr.title]="isStatusDetailsPopupOpen && activeStatusDetailsRow === row ? null : 'View Request Details'"
                          aria-label="View Request Details"
                          aria-haspopup="dialog"
                          [attr.aria-expanded]="isStatusDetailsPopupOpen && activeStatusDetailsRow === row"
                          (click)="onStatusInfoClick($event, row)">
                          <span class="material-icons status-eye-glyph" aria-hidden="true">info</span>
                        </button>
                      }
                    </span>
                  </div>
                </td>
                <td class="center">
                  <div class="action-group">
                    <button type="button" class="btn-action btn-view btn-icon-only" title="Edit" aria-label="Edit" (click)="onEditLoanClick(row)" disabled>
                      <span class="material-icons action-icon" aria-hidden="true">edit</span>
                    </button>
                    <button type="button" class="btn-action btn-run btn-icon-only" title="Download" aria-label="Download">
                      <span class="material-icons action-icon" aria-hidden="true">download</span>
                    </button>
                  </div>
                </td>
              </tr>
            }

          </tbody>
        </table>
        } @else {
          <div class="indexing-empty-state" aria-live="polite">
            @if (searchTerm.trim() && allRows.length > 0) {
              <p class="empty-state-message">No results found for "{{ searchTerm.trim() }}"</p>
            } @else {
              <p class="empty-state-message">No data available</p>
            }
          </div>
        }

        @if (isStatusDetailsPopupOpen && activeStatusDetailsRow) {
          <div
            #statusDetailsPopup
            class="status-details-popup"
            [style.left.px]="statusDetailsPopupPosition.left"
            [style.top.px]="statusDetailsPopupPosition.top"
            [style.max-height]="statusDetailsPopupMaxHeight"
            (click)="$event.stopPropagation()">
            <h4 class="status-details-title">Request Details</h4>
            <div class="status-details-grid">
              <span class="status-details-label">File Name</span>
              <span class="status-details-value">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.fileName) }}</span>

              <span class="status-details-label">Client Request ID</span>
              <span class="status-details-value">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.clientRequestId) }}</span>

              <span class="status-details-label">Request ID</span>
              <span class="status-details-value">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.requestId) }}</span>

              <span class="status-details-label">Owner</span>
              <span class="status-details-value">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.owner) }}</span>

              <span class="status-details-label">OCR Cost</span>
              <span class="status-details-value">{{ displayStatusDetailCost(activeStatusDetailsRow.statusDetails?.ocrCost ?? null) }}</span>

              <span class="status-details-label">LLM Cost</span>
              <span class="status-details-value">{{ displayStatusDetailCost(activeStatusDetailsRow.statusDetails?.llmCost ?? null) }}</span>

              <span class="status-details-label">Model</span>
              <span class="status-details-value">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.model) }}</span>

              <span class="status-details-label">Message</span>
              <span class="status-details-value status-details-message">{{ displayStatusDetailValue(activeStatusDetailsRow.statusDetails?.message) }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
  }
</div>

@if (isAddLoanModalOpen) {
  <div class="add-loan-modal-overlay" (click)="onAddLoanModalBackdropClick()">
    <div class="add-loan-modal-card" (click)="$event.stopPropagation()">
      <div class="add-loan-modal-header">
        <h3>{{ loanModalHeaderText }}</h3>
        <button
          class="add-loan-modal-close"
          (click)="requestCloseAddLoanModal()"
          aria-label="Close add package modal">
          ×
        </button>
      </div>

      <div class="add-loan-modal-body" [class.add-loan-modal-body--scroll]="loanModalMode === 'add'">
        @if (addLoanFormError) {
          <div class="add-loan-form-error">{{ addLoanFormError }}</div>
        }

        @switch (loanModalMode) {
          @case ('add') {
            <div class="add-loan-upload-field">
              <label>Upload</label>
              <div
                class="add-loan-upload-zone"
                [class.drag-active]="isAddLoanDropActive"
                role="button"
                tabindex="0"
                (click)="triggerAddLoanFilePicker()"
                (keydown)="onAddLoanUploadZoneKeydown($event)"
                (dragover)="onAddLoanUploadDragOver($event)"
                (dragleave)="onAddLoanUploadDragLeave($event)"
                (drop)="onAddLoanUploadDrop($event)">
                <span class="material-icons add-loan-upload-icon" aria-hidden="true">folder</span>
                <p class="add-loan-upload-title">Click or drag .zip or .pdf file</p>
                <p class="add-loan-upload-subtitle">Only one file is allowed</p>
                @if (addLoanSelectedFileName) {
                  <p class="add-loan-upload-file-name">Selected: {{ addLoanSelectedFileName }}</p>
                }
              </div>

              @if (addLoanFileError) {
                <div class="add-loan-upload-error">{{ addLoanFileError }}</div>
              }
            </div>

            @if (isPackageSchemaLoading) {
              <div class="add-package-loading-wrapper">
                <div class="docsila-loader" role="status" aria-live="polite" aria-label="Loading package fields">
                  <div class="beat-loader">
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                  </div>
                  <p class="loader-text">Loading package fields...</p>
                </div>
              </div>
            } @else {
            <div class="add-package-fields">
              @for (field of addPackageSchema; track field.key) {
                @if (shouldShowPackageField(field)) {
                  <div class="add-package-field" [attr.data-field-type]="field.field_type">
                    @if (field.field_type !== 'checkbox') {
                      <label class="add-package-field-label" [attr.for]="'pkg-' + field.key">
                        {{ field.label }}
                        @if (field.required) { <span class="add-package-required">*</span> }
                      </label>
                    }

                    @if ((field.field_type === 'textarea' || field.field_type === 'text') && field.is_list) {
                      <div class="add-package-chips-field">
                        <div class="add-package-chips-input-shell">
                          <input
                            type="text"
                            class="add-package-chips-input"
                            [id]="'pkg-' + field.key"
                            [ngModel]="addPackageChipDrafts[field.key] ?? ''"
                            (ngModelChange)="setPackageChipDraft(field.key, $event)"
                            (keydown.enter)="commitPackageChip(field, $event)"
                            [placeholder]="field.placeholder ?? ('Add ' + field.label)" />
                          <button
                            type="button"
                            class="add-package-chips-add-btn"
                            [attr.aria-label]="'Add ' + field.label"
                            [disabled]="!(addPackageChipDrafts[field.key] ?? '').trim()"
                            (click)="commitPackageChip(field)">+</button>
                        </div>

                        @if (asStringArray(addPackageValues[field.key]).length > 0) {
                          <div class="add-package-chips-list">
                            @for (item of asStringArray(addPackageValues[field.key]); track $index) {
                              <span class="add-package-chip">
                                <span class="add-package-chip-text" [title]="item">{{ item }}</span>
                                <button
                                  type="button"
                                  class="add-package-chip-remove"
                                  [attr.aria-label]="'Remove ' + item"
                                  (click)="removePackageChip(field, $index)">×</button>
                              </span>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                    @switch (field.field_type) {
                      @case ('text') {
                        <input
                          type="text"
                          [id]="'pkg-' + field.key"
                          [(ngModel)]="addPackageValues[field.key]"
                          [placeholder]="field.placeholder ?? ''" />
                      }
                      @case ('textarea') {
                        <textarea
                          [id]="'pkg-' + field.key"
                          [rows]="field.rows ?? 3"
                          [(ngModel)]="addPackageValues[field.key]"
                          [placeholder]="field.placeholder ?? ''"></textarea>
                      }
                      @case ('number') {
                        <input
                          type="number"
                          [id]="'pkg-' + field.key"
                          [(ngModel)]="addPackageValues[field.key]"
                          [placeholder]="field.placeholder ?? ''" />
                      }
                      @case ('checkbox') {
                        <label class="add-package-checkbox">
                          <input
                            type="checkbox"
                            [id]="'pkg-' + field.key"
                            [(ngModel)]="addPackageValues[field.key]" />
                          <span>
                            {{ field.label }}
                            @if (field.required) { <span class="add-package-required">*</span> }
                          </span>
                        </label>
                      }
                      @case ('radio') {
                        <div class="add-package-radio-group">
                          @for (opt of field.options; track opt.value) {
                            <label class="add-package-radio">
                              <input
                                type="radio"
                                [name]="'pkg-' + field.key"
                                [value]="opt.value"
                                [(ngModel)]="addPackageValues[field.key]" />
                              <span>{{ opt.label }}</span>
                            </label>
                          }
                        </div>
                      }
                      @case ('select') {
                        <select
                          [id]="'pkg-' + field.key"
                          [(ngModel)]="addPackageValues[field.key]">
                          @for (opt of field.options; track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                          }
                        </select>
                      }
                      @case ('multiselect') {
                        <div class="add-package-checkbox-list">
                          @for (opt of field.options; track opt.value) {
                            <label class="add-package-checkbox">
                              <input
                                type="checkbox"
                                [checked]="asStringArray(addPackageValues[field.key]).includes(opt.value)"
                                (change)="togglePackageMultiselect(field, opt.value, $event)" />
                              <span>{{ opt.label }}</span>
                            </label>
                          }
                        </div>
                      }
                      @case ('date') {
                        <div class="package-date-field">
                          <input
                            type="text"
                            class="date-display-input"
                            [class.is-invalid]="packageDateInvalidByKey[field.key]"
                            [id]="'pkg-' + field.key"
                            [value]="packageDateDisplayByKey[field.key] ?? ''"
                            placeholder="MM/DD/YYYY"
                            maxlength="10"
                            autocomplete="off"
                            (input)="onPackageDateInputChange(field.key, $event)"
                            (keydown)="onPackageDateInputKeydown($event)"
                            (blur)="onPackageDateInputBlur(field.key)"
                            (click)="openPackageDatePopup(field.key, $event)" />
                          <span class="material-icons date-picker-icon"
                                (click)="openPackageDatePopup(field.key, $event)"
                                aria-hidden="true">calendar_today</span>

                          @if (activePackageDatePopupKey === field.key) {
                            <div class="date-time-popup-panel package-date-popup"
                                 (mousedown)="$event.stopPropagation()"
                                 (click)="$event.stopPropagation()">
                              <mat-calendar
                                [selected]="packageDateSelectedByKey[field.key]"
                                (selectedChange)="onPackageDateSelectedChange(field.key, $event)">
                              </mat-calendar>
                            </div>
                          }
                        </div>
                      }
                      @case ('datetime') {
                        <input
                          type="datetime-local"
                          [id]="'pkg-' + field.key"
                          [(ngModel)]="addPackageValues[field.key]" />
                      }
                      @case ('json') {
                        <div class="add-package-kv-field">
                          <div class="add-package-kv-inputs">
                            <input
                              type="text"
                              class="add-package-kv-input add-package-kv-key"
                              [id]="'pkg-' + field.key + '-key'"
                              [ngModel]="addPackageKvDrafts[field.key]?.key ?? ''"
                              (ngModelChange)="setPackageKvKeyDraft(field.key, $event)"
                              (keydown.enter)="commitPackageKv(field, $event)"
                              placeholder="Key" />
                            <input
                              type="text"
                              class="add-package-kv-input add-package-kv-value"
                              [id]="'pkg-' + field.key + '-value'"
                              [ngModel]="addPackageKvDrafts[field.key]?.value ?? ''"
                              (ngModelChange)="setPackageKvValueDraft(field.key, $event)"
                              (keydown.enter)="commitPackageKv(field, $event)"
                              placeholder="Value" />
                            <button
                              type="button"
                              class="add-package-kv-add-btn"
                              [attr.aria-label]="'Add ' + field.label"
                              [disabled]="!(addPackageKvDrafts[field.key]?.key ?? '').trim()"
                              (click)="commitPackageKv(field)">+</button>
                          </div>

                          @if (getPackageKvEntries(field).length > 0) {
                            <div class="add-package-chips-list">
                              @for (entry of getPackageKvEntries(field); track entry.key) {
                                <span class="add-package-chip">
                                  <span class="add-package-chip-text" [title]="entry.key + ': ' + entry.value">{{ entry.key }}: {{ entry.value }}</span>
                                  <button
                                    type="button"
                                    class="add-package-chip-remove"
                                    [attr.aria-label]="'Remove ' + entry.key"
                                    (click)="removePackageKv(field, entry.key)">×</button>
                                </span>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                    }

                    @if (field.description) {
                      <div class="add-package-field-help">{{ field.description }}</div>
                    }
                    @if (addPackageFieldErrors[field.key]) {
                      <div class="add-package-field-error">{{ addPackageFieldErrors[field.key] }}</div>
                    }
                  </div>
                }
              }
            </div>
            }
          }

          @case ('edit') {
            <div class="add-loan-form-grid">
              <div class="add-loan-form-field">
                <label>Loan Number</label>
                <input
                  type="text"
                  [(ngModel)]="addLoanLoanNumber"
                  placeholder="Enter loan number"
                  maxlength="80" />
              </div>

              <div class="add-loan-form-field">
                <label>Borrower Name(s) Comma Separated</label>
                <input
                  type="text"
                  [(ngModel)]="addLoanBorrowerNames"
                  placeholder="Enter borrower names"
                  maxlength="180" />
              </div>

              <div class="add-loan-form-field">
                <label>Priority</label>
                <select [(ngModel)]="addLoanSelectedPriority">
                  @for (priority of addLoanPriorityOptions; track priority) {
                    <option [value]="priority">{{ priority }}</option>
                  }
                </select>
              </div>

              <div class="add-loan-form-field">
                <label>Checklist Type</label>
                <select [(ngModel)]="addLoanSelectedChecklistType">
                  @for (checklistType of addLoanChecklistTypeOptions; track checklistType) {
                    <option [value]="checklistType">{{ checklistType }}</option>
                  }
                </select>
              </div>
            </div>

            <div class="add-loan-upload-field">
              <label>Upload</label>
              <div
                class="add-loan-upload-zone"
                [class.drag-active]="isAddLoanDropActive"
                role="button"
                tabindex="0"
                (click)="triggerAddLoanFilePicker()"
                (keydown)="onAddLoanUploadZoneKeydown($event)"
                (dragover)="onAddLoanUploadDragOver($event)"
                (dragleave)="onAddLoanUploadDragLeave($event)"
                (drop)="onAddLoanUploadDrop($event)">
                <span class="material-icons add-loan-upload-icon" aria-hidden="true">folder</span>
                <p class="add-loan-upload-title">Click or drag .zip or .pdf file</p>
                <p class="add-loan-upload-subtitle">Only one file is allowed</p>
                @if (addLoanSelectedFileName) {
                  <p class="add-loan-upload-file-name">Selected: {{ addLoanSelectedFileName }}</p>
                }
              </div>

              @if (addLoanFileError) {
                <div class="add-loan-upload-error">{{ addLoanFileError }}</div>
              }
            </div>
          }
        }
      </div>

      <div class="add-loan-modal-footer">
        <button class="add-loan-btn-cancel" (click)="requestCloseAddLoanModal()">Cancel</button>
        <button class="add-loan-btn-save" [disabled]="!canSubmitAddPackage" (click)="onSubmitAddLoan()">
          {{ isSubmittingAddPackage ? 'Adding...' : loanModalPrimaryActionText }}
        </button>
      </div>
    </div>
  </div>
}

<input
  #addLoanZipInput
  type="file"
  accept=".zip,.pdf,application/zip,application/x-zip-compressed,multipart/x-zip,application/pdf"
  style="display: none;"
  (change)="onAddLoanFileInputChange($event)" />
